import { createContext, useContext } from "react";

/**
 * The time zone dates render in.
 *
 * A leaf formatting hook must not call the current-user query itself — that is what would force
 * every consumer of a preview to live inside the assistant's data layer. The browser's own zone is
 * the default, so a missing provider degrades to a plausible time rather than a wrong one, which is
 * what makes this safe to read from a leaf.
 *
 * `useContext` and `.Provider` rather than React 19's `use`/context-as-provider: `@workleap-ai/client`
 * still declares a React 18 peer range, and these components ship to it.
 */
export const TimeZoneContext = createContext<string>(Intl.DateTimeFormat().resolvedOptions().timeZone);

export const useTimeZone = () => useContext(TimeZoneContext);
